import "./index.css";
import About from "./About";
import Characters from "./Characters";
import Calendar from "./Calendar";
// import Tariffs from "./Tariffs";
import Apps from "./Apps";
import usePageTitle from "../../hooks/usePageTitle";

export default function MainPage() {
  usePageTitle("СобеседникИИ – твои надежные компаньоны");
  return (
    <div className="text-[#292929] overflow-hidden">
      <About />
      <Characters />
      <Calendar />
      {/* <Tariffs /> */}
      <Apps />
    </div>
  );
}
